import './index.scss';
import { defineComponent, h, PropType } from 'vue';
import { Dialog } from '@phi/components';
import { Length } from '@frontend/Units';
import { FormNumber, FormWithLabels, Label } from '@components/form';
import { processReadCoordsModal } from '@frontend/ui_display';
import { read_coords_props as props, showing_read_coordinates_modal } from '../../state';
import { round_decimals } from '@features/decimal-approximation';

export const ReadCoordinatesModal = defineComponent({
    props: {
        units: {
            required: true,
            type: String as PropType<Length>,
        },
    },

    methods: {
        cancel() {
            showing_read_coordinates_modal.value = false;
        },

        confirm() {
            if (props.vid)
                processReadCoordsModal(props.x, props.y, props.z, props.vid);
            showing_read_coordinates_modal.value = false;
        },

        reset() {
            props.left = 0;
            props.top = 0;
            props.x = 0;
            props.y = 0;
            props.z = 0;
            props.vid = undefined;
        },
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    watch: {
        show(value: boolean) {
            if (!value)
                setTimeout(() => this.reset(), 500);
        },
    },

    render() {
        return h(Dialog, {
            show: showing_read_coordinates_modal.value,
            'onUpdate:show': x => showing_read_coordinates_modal.value = x,
            close_label: 'Cancel',
            onClose: () => showing_read_coordinates_modal.value = false,
            confirm_label: 'Set',
            onConfirm: this.confirm,
            id: 'readCoordsModal',
            title: `Enter coordinates (${this.units})`,
            width: 'extra-narrow',
            backdrop: false,
        }, () => h(FormWithLabels, { gap: 'tight', width: '2rem' }, () => [
            h(Label, null, {
                label: () => h('span', 'X'),
                input: () => h(FormNumber, {
                    value: props.x,
                    'onUpdate:value': x => props.x = round_decimals(x),
                    change: true,
                }),
            }),

            h(Label, null, {
                label: () => h('span', 'Y'),
                input: () => h(FormNumber, {
                    value: props.y,
                    'onUpdate:value': y => props.y = round_decimals(y),
                    change: true,
                }),
            }),

            h(Label, null, {
                label: () => h('span', 'Z'),
                input: () => h(FormNumber, {
                    value: props.z,
                    'onUpdate:value': z => props.z = round_decimals(z),
                    change: true,
                }),
            }),
        ]));
    }
});
